// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1-TM3","content":"LoadingAlert_content__143Yb"};